import type { ParticipantId } from "@pack-it-up/shared";
import { participantsOf, type ParticipantContext, type TemplateParticipants } from "@pack-it-up/core";

// The assignment editors only ever need a name per participant id, and both kinds of
// list have people now: a trip's `members` and, since issue #185, a template's
// `participants` (its default travelers). One shape lets the composer, the add row and
// the row-edit form serve the trip editor and the template editor alike.
export interface Person {
  id: ParticipantId;
  displayName: string;
}

// Issue #188 — takes the `ParticipantContext` both kinds of list satisfy (a trip
// directly, a template via `participantContextOf`), so the list components below it
// serve either without knowing which they're rendering.
export const peopleOf = (list: ParticipantContext): Person[] =>
  participantsOf(list).map((id) => ({ id, displayName: list.members[id]?.profile.displayName ?? "?" }));

export const peopleOfTemplate = (participants: TemplateParticipants | undefined): Person[] =>
  Object.entries(participants ?? {}).map(([id, p]) => ({ id: id as ParticipantId, displayName: p.displayName }));

export const nameOf = (people: Person[], id: ParticipantId): string =>
  people.find((p) => p.id === id)?.displayName ?? "?";
